import UserThumbnail from '@atom/components/common/UserThumbnail';
import { UserDetail } from '@atom/types/user';
import userUtilities from '@atom/utilities/userUtilities';

import classes from './workSummaryTray.module.css';

interface Props {
  user: UserDetail;
}

const UserRow = ({ user }: Props) => {
  return (
    <div className={classes.userRowContainer}>
      <div className={classes.userThumbnailContainer}>
        <UserThumbnail
          image={user.photoUrl}
          alt={`${user.firstName} ${user.lastName}`}
        />
      </div>
      <div className={classes.userDetailContent}>
        <div className={classes.userNameContainer}>
          {userUtilities.getUserFullName(user)}
        </div>
        <div className={classes.userEmailContainer}>{user.email}</div>
      </div>
    </div>
  );
};

export default UserRow;
